import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FullScreenOverlay } from '@bibliocommons/base-full-screen-overlay';
import { selectOpenOverlays } from 'app/selectors/ui/FullScreenOverlaySelector';

export function FullScreenOverlayContainer({ overlayKey, open, ...props }) {
  return <FullScreenOverlay open={open} key={overlayKey} {...props} />;
}

FullScreenOverlayContainer.propTypes = {
  overlayKey: PropTypes.string.isRequired,
  dataKey: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func
};

const mapStateToProps = (state, ownProps) => ({
  open: ownProps.open || selectOpenOverlays(state).has(ownProps.overlayKey)
});

export default connect(mapStateToProps)(FullScreenOverlayContainer);
